import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { B2cSigninPhoneComponent } from './components/b2c-signin/b2c-signin-phone.component';
import { B2cSigninComponent } from './components/b2c-signin/b2c-signin.component';
import { LoginPhoneComponent } from './components/login-phone/login-phone.component';
import { LoginComponent } from './components/login/login.component';
import { SignUpMobilePhoneB2CComponent } from './components/signup-mobile-phone-b2c/signup-mobile-phone-b2c.component';
import { SignUpMobilePhoneComponent } from './components/signup-mobile-phone/signup-mobile-phone.component';
import { LoginMainComponent } from './login.main/login.main.component';

@NgModule({
  declarations: [
    LoginComponent,
    B2cSigninComponent,
    B2cSigninPhoneComponent,
    LoginPhoneComponent,
    SignUpMobilePhoneComponent,
    SignUpMobilePhoneB2CComponent,
    LoginMainComponent,
  ],
  imports: [CommonModule, RouterModule, AuthRoutingModule, ReactiveFormsModule, SharedModule],
  exports: [LoginComponent, SignUpMobilePhoneComponent],
})
export class AuthModule {}
